module.exports = __webpack_public_path__ + "static/media/robot.0365230a.png";